module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Medium.71658781.ttf";